import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SgSessionTokenService {
  private sgSessionToken = '';

  setToken(token: string): void {
    this.sgSessionToken = token || '';
  }

  getToken(): string {
    return this.sgSessionToken;
  }

  clearToken(): void {
    this.sgSessionToken = '';
  }
}
